import { render, staticRenderFns } from "./fangList.vue?vue&type=template&id=bad95a14&scoped=true"
import script from "./fangList.vue?vue&type=script&lang=js"
export * from "./fangList.vue?vue&type=script&lang=js"
import style0 from "./fangList.vue?vue&type=style&index=0&id=bad95a14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad95a14",
  null
  
)

export default component.exports